import React, { useState, useEffect } from "react";
import {
    isGrotArrangement,
    labelGrotJaNej
} from "../minskog/comps/SellTimber/helpers/sellTimberShared";

const ATTACHMENT_NAME_MAX_BASE = 32;

/** e.g. `very-long-name…` → `very-long-name…png` (32 chars before extension). */
function truncateAttachmentFileName(fileName, maxBaseLen = ATTACHMENT_NAME_MAX_BASE) {
    const name = fileName == null ? "" : String(fileName);
    if (!name) return "";
    const lastDot = name.lastIndexOf(".");
    if (lastDot <= 0 || lastDot === name.length - 1) {
        return name.length <= maxBaseLen ? name : `${name.slice(0, maxBaseLen)}...`;
    }
    const base = name.slice(0, lastDot);
    const ext = name.slice(lastDot + 1);
    if (base.length <= maxBaseLen) return name;
    return `${base.slice(0, maxBaseLen)}...${ext}`;
}

const AdTables = ({attachmentRef}) => {
    const [showSI, setShowSI] = useState(false);
    const [selectedRows, setSelectedRows] = useState({
        AdsInfo: [],
        ForestInfo: [],
        ForestTable: [],
    });
    
    const { ad, trustedBuyer } = Window.react_data;
    const static_path  = Window.static_path;
    const isLeveransvirke = ad.type === "Leveransvirke";
    const isGrot = isGrotArrangement(ad);

    const adsInfo = {
        "Första anbudsdag": ad.start_time,
        "Sista anbudsdag": ad.end_time,
        "Åtgärd": ad.arrangement_types,
        "Gallringsuttag": ad.get_thinning,
        "Kontraktstyp": isGrot ? null : ad.name_display,
        "Avverkningsperiod från": ad.felling_start_time,
        "Avverkningsperiod till": ad.felling_end_time,
        "Leveransår": ad.delivery_year,
        "Upphämtningsdatumet": ad.pickup_date,
        "Antal dagar till betalning": ad.days_to_payment,
        "Ansvarig för avverkningsanmälan": ad.felling_application_responsible,
        "Kommun": ad.municipality,
        "Registrerad för mervärdesskatt": ad.more_tax,
        "Taxeras som lantbruksenhet": ad.agricultural_unit,
        "Önskas dellikvid / förskottsbetalning / delbetalning": ad.part_or_advance_payment_allowed,
        "Detaljer ang. dellikvid / förskottsbetalning / delbetalning": ad.part_or_advance_payment_description,
        "Medlemskap i skogsägarförening": ad.get_seller_forest_owner_union_membership_display,
    };

    const forestInfo = isGrot
        ? {
            "Areal": (!isLeveransvirke && ad.total_area_ha) ? `${ad.total_area_ha} ha` : null,
            "Fastighetsbeteckning": trustedBuyer ? ad.description_of_property : null,
            "Volym biobränsle": ad.grot_volume ? `${String(ad.grot_volume).trim()} m³` : null,
            "Biobränslet täckt": ad.grot_heap_covered ? labelGrotJaNej(ad.grot_heap_covered) : null,
            "Biobränslet uppsamlat": ad.grot_collected ? labelGrotJaNej(ad.grot_collected) : null
        }
        : {
            "Areal": (!isLeveransvirke && ad.total_area_ha) ? `${ad.total_area_ha} ha` : null,
            "Fastighetsbeteckning": trustedBuyer ? ad.description_of_property : null,
            "Uttag": ad.total_volume ? `${Math.round(ad.total_volume)} m³fub` : null,
            /*"Beståndets beteckning": ad.habitat_index,
        "Beståndets ålder": ad.property_age,
        "Grotuttag medges": ad.grot_included,*/
            /*"Antal träd": ad.num_trees,
        "Medelstam (m3fub)": ad.average_trunk,
        "Skogen står upp": isLeveransvirke ? ad.standing_forest : null,
        "FSC-certifikat": ad.fsc_certified,
        "PEFC-certifikat": ad.pefc_certified,
        "Spara fröträd": ad.save_seed_trees,
        "Hur är fröträd markerade": ad.seed_tree_marking_description,
        "Återplantering": ad.replanting,
        "Markberedning": !isLeveransvirke ? ad.ground_preparation : null,
        "Förröjning": !isLeveransvirke ? ad.precleaning_needed : null,
        "Hyggerensing": ad.ground_clearing,
        "Vägbygge eller vägförstärkning": ad.buyer_builds_or_reinforces_road,
        "Kompletterande information gällande skogsvård": ad.service_comments,*/
        };

    const showForestSectionsTable =
        !isGrot && ad.section_assortments && ad.section_assortments.length > 0;

    const cleanNumbers = (num) =>
        Math.round(Number(num)).toString().replace(".0", "").replace(".", ",");

    const formatValue = (value) => {
        if (value === true) return "Ja";
        if (value === false) return "Nej";
        if (typeof value === "number") return value.toFixed(2);
        return value;
    };

    const toggleRowSelection = (tableKey, index) => {
        setSelectedRows((prevSelected) => {
            const selectedCopy = [...prevSelected[tableKey]];
            const isSelected = selectedCopy.includes(index);
            const newSelected = isSelected
                ? selectedCopy.filter((i) => i !== index)
                : [...selectedCopy, index];

            return {
                ...prevSelected,
                [tableKey]: newSelected,
            };
        });
    };

    const renderInfoTable = (data, tableKey) => (
        <table className="table break-words fs-7 w-full [&_td]:p-2 [&_th]:p-2 [&_td]:text-left [&_th]:text-left">
            <tbody style={{ borderColor: "#C6C9C9" }}>
                {Object.entries(data).map(
                    ([key, value], index) =>
                        value !== null &&
                        value !== undefined &&
                        value !== "" &&
                        (tableKey === "AdsInfo" ? value : true) && (
                            <tr
                                key={key}
                                className="fs-7 border-b border-gray-300"
                                style={{
                                    backgroundColor: selectedRows[tableKey]?.includes(index)
                                        ? "#60DFE0"
                                        : "inherit",
                                    color: selectedRows[tableKey]?.includes(index)
                                        ? "#1C332A"
                                        : "inherit",
                                }}
                                onClick={() => toggleRowSelection(tableKey, index)}
                            >
                                <td className="break-words" style={{ maxWidth: "150px" }}>
                                    {key}:
                                </td>
                                <td className="break-words">
                                    {formatValue(value)}
                                </td>
                            </tr>
                        )
                )}
            </tbody>
        </table>
    );

    const renderForestTableHeader = () => (
        <tr>
            <th style={{ fontWeight: "normal" }}>#Avd</th>
            <th style={{ fontWeight: "normal" }}>
                {isLeveransvirke ? "" : "Uttag"}
            </th>
            {!isLeveransvirke && showSI && (
                <th style={{ fontWeight: "normal" }}>SI</th>
            )}
            {!isLeveransvirke && (
                <th style={{ fontWeight: "normal" }}>Area</th>
            )}
            {ad.wood_types &&
                ad.wood_types.map((woodName, index) => (
                    <th key={index} style={{ fontWeight: "normal" }}>
                        {woodName === "default" ? "Löv" : woodName}
                    </th>
                ))}
        </tr>
    );

    const renderForestTableBody = () => {
        const tableRows = ad.section_assortments;
        let total_vol = 0;
        let total_area = 0.0;
        let woodTotals = {};

        if (tableRows && tableRows.length > 0) {
            tableRows.forEach((item) => {
                if (item.habitat_index && !showSI) {
                    setShowSI(true);
                }
                total_vol += item.total_volume || 0;
                total_area += parseFloat(item.Hectares || 0);

                Object.keys(item.wood || {}).forEach((woodType) => {
                    woodTotals[woodType] =
                        (woodTotals[woodType] || 0) + (item.wood[woodType] || 0);
                });
            });
        }

        return (
            <>
                {tableRows &&
                    tableRows.map((item, index) => (
                        <tr
                            key={index}
                            style={{
                                backgroundColor: selectedRows.ForestTable.includes(index)
                                    ? "#60DFE0"
                                    : "inherit",
                                color: selectedRows.ForestTable.includes(index)
                                    ? "#1C332A"
                                    : "inherit",
                            }}
                            onClick={() => toggleRowSelection("ForestTable", index)}
                        >
                            <td>{item.name}</td>
                            <td>{`${cleanNumbers(item.total_volume)} m³fub`}</td>
                            {!isLeveransvirke && showSI && <td>{item.habitat_index}</td>}
                            {!isLeveransvirke && (
                                <td>{`${Number(item.Hectares).toFixed(1).replace(".", ",")} ha`}</td>
                            )}
                            {ad.wood_types.map((woodType) => (
                                <td key={woodType}>
                                    {item.wood && item.wood[woodType]
                                        ? `${cleanNumbers(item.wood[woodType])} m³fub`
                                        : "0 m³fub"}
                                </td>
                            ))}
                        </tr>
                    ))}

                <tr className="bg-primary-core-100">
                    <td className="font-bold">Totalt:</td>
                    {!isLeveransvirke && (
                        <>
                            <td className="font-bold">{`${cleanNumbers(total_vol)} m³fub`}</td>
                            {showSI && <td className="font-bold"></td>}
                            <td className="font-bold">{`${cleanNumbers(total_area)} ha`}</td>
                        </>
                    )}
                    {isLeveransvirke && (
                        <td className="font-bold">{`${cleanNumbers(total_vol)} m³fub`}</td>
                    )}
                    {ad.wood_types.map((woodType) => (
                        <td key={woodType} className="font-bold">
                            {`${cleanNumbers(woodTotals[woodType] || 0)} m³fub`}
                        </td>
                    ))}
                </tr>
            </>
        );
    };

    const renderAttachments = () => (
        <div id="attachments">
            <h3 className="mb-6 fs-5 font-medium">Bilagor</h3>
            <table className="table w-full [&_td]:p-2 [&_th]:p-2 [&_td]:text-left [&_th]:text-left">
                <tbody style={{ borderColor: "#C6C9C9" }}>
                    {ad.attachments?.map((attachment, index) => (
                        <tr key={index} className="border-b border-gray-300 hover:bg-gray-300">
                            <td>
                                <a
                                    href={attachment.file_url}
                                    className="flex fs-6 gap-2 items-center"
                                    target="_blank"
                                    rel="noreferrer"
                                    title={attachment.original_file_name}
                                >
                                    <img
                                        src={`${static_path}img/icons/download.svg`}
                                        height="24px"
                                        width="24px"
                                        className="supp-forest-green-filter p-1"
                                        alt="Download"
                                    />
                                    {truncateAttachmentFileName(attachment.original_file_name)}
                                </a>
                            </td>
                        </tr>
                    ))}
                    <tr className="border-b border-gray-300 hover:bg-gray-300">
                        <td>
                            <a href={`/auctions/${ad.id}/kml/`} className="flex fs-6 gap-2 items-center">
                                <img
                                    src={`${static_path}img/icons/download.svg`}
                                    height="24px"
                                    width="24px"
                                    className="supp-forest-green-filter p-1"
                                    alt="Download"
                                />
                                Kartfil (kml)
                            </a>
                        </td>
                    </tr>
                    <tr className="border-b border-gray-300 hover:bg-gray-300">
                        <td>
                            <a
                                href={`/auctions/${ad.id}/shapefile/`}
                                className="flex fs-6 gap-2 items-center"
                            >
                                <img
                                    src={`${static_path}img/icons/download.svg`}
                                    height="24px"
                                    width="24px"
                                    className="supp-forest-green-filter p-1"
                                    alt="Download"
                                />
                                Kartfil (zip)
                            </a>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    );

    const displayComments = ad.comments;
    const hasComments = displayComments && displayComments.length > 0;
    const hasAttachments = ad.attachments?.length > 0;
    const isOtherAdsEmpty = !ad.other_ads_for_owner || ad.other_ads_for_owner.length === 0;

    return (
        <div className="primary-dark flex flex-wrap md:flex-row flex justify-between mt-6 mx-1">
            {hasComments && trustedBuyer && (
                <div className="w-full lg:w-11/12 bg-neutral-cloud mb-6 p-6" style={{ borderRadius: "12px" }}>
                    <p className="mb-6 fs-5 font-medium">Information</p>
                    <p className="fs-6" style={{ whiteSpace: "pre-line" }}>{displayComments}</p>
                </div>
            )}

            <div className="lg:w-[calc(50%-8px)] w-full mb-6 p-6 bg-neutral-cloud" style={{ borderRadius: "12px" }}>
                <p className="mb-6 fs-5 font-medium">Annonsdetaljer</p>
                {renderInfoTable(adsInfo, "AdsInfo")}
            </div>

            <div className="lg:w-[calc(50%-8px)] w-full mb-6 p-6 bg-neutral-cloud" style={{ borderRadius: "12px" }}>
                <p className="mb-6 fs-5 font-medium">Information om skogen</p>
                {renderInfoTable(forestInfo, "ForestInfo")}
            </div>

            {showForestSectionsTable ? (
                <div className="w-full lg:w-full mb-6 p-6 bg-neutral-cloud" style={{ borderRadius: "16px" }}>
                    <p className="mb-6 fs-5 font-medium">Skogsuppgifter</p>
                    <div className="overflow-x-auto">
                        <table className="table w-full [&_td]:p-2 [&_th]:p-2 [&_td]:text-left [&_th]:text-left [&_tbody_tr:nth-child(odd)]:bg-neutral-cloud-100">
                            <thead className="fs-7">{renderForestTableHeader()}</thead>
                            <tbody className="fs-7">{renderForestTableBody()}</tbody>
                        </table>
                    </div>
                </div>
            ) : null}

            {!isOtherAdsEmpty && (
                <div className="lg:w-1/3 w-full p-6 mb-6 lg:me-4 bg-neutral-cloud" style={{ borderRadius: "12px" }}>
                    <div>
                        <p className="mb-6 fs-5 font-medium">Andra annonser från denna skogsägare</p>
                        <table className="table w-full [&_td]:p-2 [&_th]:p-2 [&_td]:text-left [&_th]:text-left">
                            <tbody style={{ borderColor: "#C6C9C9" }}>
                                {ad.other_ads_for_owner.map((otherAd) => (
                                    <tr key={otherAd.id}>
                                        <td>
                                            <a className="flex fs-6" href={`/auctions/${otherAd.id}`}>
                                                <img
                                                    src={`${static_path}img/icons/viewPage.svg`}
                                                    height="28px"
                                                    width="28px"
                                                    className="supp-forest-green-filter p-1 pb-2"
                                                    alt="ViewPage"
                                                />
                                                {otherAd.label}
                                            </a>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            )}

            {trustedBuyer && (hasAttachments || showForestSectionsTable) && (
                <div className={`${isOtherAdsEmpty ? "lg:w-7/12" : "lg:w-1/2"} ${!isOtherAdsEmpty ? "lg:ml-6" : "lg:ml-0"} w-full rounded p-6 mb-6 bg-neutral-cloud`} style={{ borderRadius: "12px", display: hasAttachments || showForestSectionsTable ? 'block' : 'none' }} ref={attachmentRef} id='attachments'>
                    {renderAttachments()}
                </div>
            )}
        </div>
    );
};

export default AdTables;